<template>
  <q-page padding>
    <base-form :resource="$route.meta.resource" :id="this.$route.params.id" />
  </q-page>
</template>

<script>
export default {
  name: 'EditForm'
}
</script>

<style>
</style>
